



import React, { FC, ReactElement, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';

import Modal from '../../Modal';
import { FilledButton, OutlinedButton } from '../../Buttons';
import ErrorContainer from './Container';

interface Props {
  onReload: ()=> void;
}
const LoadingError: FC<Props> = observer(({ onReload }: Props): ReactElement => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const tryAgainButtonDescription = t('pages.landing.loadingError.buttons.tryAgain.description') as string;
  const tryAgainButtonText = t('pages.landing.loadingError.buttons.tryAgain.label') as string;
  const helpButtonDescription = t('pages.landing.common.buttons.help.description') as string;
  const helpButtonText = t('pages.landing.common.buttons.help.label') as string;
  const modalTitleError = t('pages.landing.common.modal.help.title') as string;
  const modalTextError = t('pages.landing.common.modal.help.text') as string;
  const modalButtonTextError = t('pages.landing.common.modal.help.button') as string;

  return <ErrorContainer>
    <Modal 
      title={modalTitleError} 
      text={modalTextError} 
      buttonText={modalButtonTextError} 
      open={modalOpen} 
      onClose={() => setModalOpen(false)} 
    />
    <Grid container spacing={3} direction='column' alignItems='stretch'>
      <Grid item>
        <FilledButton 
          width={'21.875rem'} 
          text={tryAgainButtonText} 
          description={tryAgainButtonDescription} 
          handleClick={onReload} 
        />
      </Grid>
      <Grid item>
        <OutlinedButton 
          width={'21.875rem'} 
          text={helpButtonText} 
          description={helpButtonDescription} 
          handleClick={() => setModalOpen(true)} 
        />
      </Grid>
    </Grid>
  </ErrorContainer>;

});

export default LoadingError;